import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

import Eye from "./Eye";
import MainInterface from "./Login/MainInterface";
import SignUp from "./Login/SignUp";
import Login from "./Login/Login";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../3- actions/users";

function Nav({ popup, setPopUp, interfaces, setInterfaces }) {
  const dispatch = useDispatch();
  const localUser = useSelector((state) => state.user.LocalUser);
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("profile")));

  const [userPopup, setUserPopup] = useState(false);
  const [nav, setNav] = useState(false);

  // on page loads setUser to localStorage
  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("profile")));
    setNav(false);
  }, []);

  // to handle if scroll 1px down set state to false
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY >= 100) {
        setNav(false);
        setUserPopup(false);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // to handle logout

  function logOut() {
    dispatch(logoutUser());
    setUser(null);
    setNav(false);
    setUserPopup(false);
  }
  const handleClick = () => {
    setUserPopup(false);
    setNav(false);
  };

  const ProfilePopUp = (
    <div>
      <div
        onClick={() => {
          setUserPopup(false);
        }}
        className={
          userPopup
            ? "fixed purple-full-width backdrop-blur-[50px] bg-secondary/20 m-0 object-contain h-[500vh] top-0 left-0 right-0 bottom-0 w-full opacity-100 duration-500 ease-in-out"
            : "fixed inset-0 purple-full-width backdrop-blur-[50px] bg-secondary/20  h-[100vh] w-full opacity-0 duration-500 ease-in-out pointer-events-none"
        }
      ></div>

      <div
        className={
          userPopup
            ? "w-full lg:w-[600px] h-auto bg-tertiary absolute top-full right-0 opacity-100 duration-500 ease-in-out"
            : "w-full lg:w-[600px] h-auto bg-tertiary absolute top-[130%] right-0 opacity-0 duration-500 ease-in-out pointer-events-none"
        }
      >
        <div className="px-[15px] sm:px-10 pb-10">
          <div className="pt-6">
            <div className="flex justify-start items-center gap-x-6">
              {localUser?.picture ? (
                <div className="flex flex-none uppercase justify-center items-center h-[50px] w-[50px] bg-secondary z-50 relative rounded-full">
                  <img
                    className="rounded-full  w-full h-full object-cover"
                    src={localUser?.picture}
                    referrerPolicy="no-referrer"
                    alt={localUser?.firstName}
                  />
                </div>
              ) : (
                <div
                  title="My Profile"
                  className="flex-none pointer-events-none flex uppercase justify-center items-center h-[60px] w-[60px] bg-primary rounded-full"
                >
                  {localUser?.firstName?.[0] || "#"}
                </div>
              )}
              <div className="text-secondary flex  justify-start flex-col items-start  text-[16px]">
                <div className="flex justify-center items-center gap-x-4">
                  <h2 className="line-clamp-1 pointer-events-none capitalize font-SoraR hover:text-primary relative border-primary duration-500 ease-in-out text-[15px] sm:text-[16px]">
                    {localUser?.firstName || "#####"}{" "}
                    {localUser?.lastName || "#####"}
                  </h2>
                </div>
                <p className="line-clamp-1 font-SoraR text-secondary/80 text-[13px] sm:text-[14px]">
                  {localUser?.email || "#############"}
                </p>
              </div>
            </div>
            <div className="w-full h-[1px] bg-secondary/20 my-6"></div>
          </div>
          <div className="flex flex-col gap-y-4">
            <NavLink onClick={handleClick} to={`/users/${localUser?._id}`}>
              <div className="px-6 py-8 relative group hover:bg-primary duration-500 ease-in-out cursor-pointer h-[140px] overflow-hidden flex flex-col justify-start items-start  w-full border-[1px] border-primary">
                <h2 className="font-SoraR text-[14px] sm:text-[16px] group-hover:text-tertiary  duration-500 ease-in-out text-primary">
                  Profile
                </h2>
                <p className="uppercase line-clamp-1 group-hover:text-tertiary/80  duration-500 ease-in-out font-SoraR text-[13px] text-secondary/40">
                  id:{" "}
                  {localUser?._id?.slice(0, 15) ||
                    "############################"}
                </p>
                <div className="scale-[3.6] md:scale-[4.5] lg:scale-[3] group-hover:bottom-[-20px] duration-500 ease-in-out z-[100000] absolute right-[35px] md:right-[50px] lg:right-[50px] bottom-0">
                  <div className="ProfilePopup navZoom">
                    <div className="eye-parento-4"></div>
                    <div className="eye-parento-2">
                      <div className="eye-parento-3"></div>
                    </div>
                  </div>
                </div>
              </div>
            </NavLink>
            <NavLink
              onClick={() => {
                setUserPopup(false);
                setNav(false);
              }}
              to={`/favorites`}
            >
              <div className="px-6 py-4 relative group hover:bg-primary duration-500 ease-in-out cursor-pointer h-auto overflow-hidden flex flex-col justify-start items-start  w-full border-[1px] border-primary">
                <h2 className="font-SoraR text-[14px] sm:text-[16px] group-hover:text-tertiary  duration-500 ease-in-out text-primary">
                  Favorites
                </h2>
              </div>
            </NavLink>
            <NavLink
              onClick={() => {
                setUserPopup(false);
                setNav(false);
              }}
              to={`/BadgesSystem`}
            >
              <div className="px-6 py-4 relative group hover:bg-primary/90 duration-500 ease-in-out cursor-pointer h-auto overflow-hidden flex flex-col justify-start items-start  w-full  bg-primary">
                <h2 className="font-SoraR text-[14px] sm:text-[16px] text-tertiary  duration-500 ease-in-out">
                  Badges System
                </h2>
              </div>
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
  return (
    <div>
      <div className="purple-full-width -z-10 bg-gradient-to-b from-primary/30 to-secondary  top-0 w-full h-[50vh]" />
      <div>
        <div className="z-[100] relative text-tertiary flex  w-full items-center h-[90px] lg:h-[117px]">
          {/* mobile view */}
          <div className="lg:hidden z-[110] flex w-full px-[15px] md:px-0 justify-between items-center">
            {user ? (
              <div>
                {localUser?.picture ? (
                  <div>
                    <div
                      title="My Profile"
                      className="cursor-pointer w-12 h-12 bg-secondary rounded-full relative z-[50] flex justify-center items-center"
                    >
                      <img
                        onClick={() => {
                          setUserPopup((prev) => !prev);
                          setNav(false);
                        }}
                        className="rounded-full object-cover w-full h-full"
                        src={localUser.picture}
                        referrerPolicy="no-referrer"
                        alt={localUser.firstName}
                      />
                    </div>
                    {ProfilePopUp}
                  </div>
                ) : (
                  <div>
                    <div
                      onClick={() => {
                        setUserPopup((prev) => !prev);
                      }}
                      title="My Profile"
                      className="cursor-pointer capitalize w-12 h-12 bg-primary rounded-full relative z-[50] flex justify-center items-center"
                    >
                      {localUser?.firstName?.[0] || "#"}
                    </div>
                    {ProfilePopUp}
                  </div>
                )}
              </div>
            ) : (
              <div></div>
            )}
            <div
              onClick={() => {
                setNav((prev) => !prev);
                setUserPopup(false);
              }}
              className="z-50 group cursor-pointer space-y-2 flex flex-col rotate-180 "
            >
              <div
                className={
                  nav
                    ? "w-[48px] h-[1px] duration-300 ease-in-out translate-y-[9px] rotate-45 bg-tertiary"
                    : "w-[48px] h-[1px] duration-300 ease-in-out translate-y-0 rotate-0 bg-tertiary"
                }
              ></div>
              <div
                className={
                  nav
                    ? "w-0 duration-300 ease-in-out h-[1px] bg-tertiary"
                    : "w-[30px] duration-300 ease-in-out group-hover:w-[48px] h-[1px] bg-tertiary"
                }
              ></div>
              <div
                className={
                  nav
                    ? "w-[48px] h-[1px] duration-300 ease-in-out -translate-y-[9px] -rotate-45 bg-tertiary"
                    : "w-[48px] h-[1px] duration-300 ease-in-out translate-y-0 rotate-0 bg-tertiary"
                }
              ></div>
            </div>
          </div>
          {/* mobile view */}
          <div
            className={
              nav
                ? "w-full h-full bg-secondary fixed lg:relative z-[100] flex justify-center items-center lg:flex-row lg:justify-between lg:bg-secondary/0 flex-col gap-y-10 text-center top-0 inset-0 -translate-y-0 duration-500 ease-in-out"
                : "w-full h-full bg-secondary fixed lg:relative z-[100] flex justify-center items-center lg:flex-row lg:justify-between lg:bg-secondary/0 flex-col gap-y-10 text-center  top-0 inset-0 -translate-y-full lg:-translate-y-0 duration-500 ease-in-out"
            }
          >
            <div className="z-[100] flex-col lg:flex-row flex space-y-10 lg:space-y-0  lg:space-x-10">
              <NavLink
                // className=" text-tertiary hover:text-primarys duration-300 ease-in-out"
                to="/browse"
                title="Explore The Most Popular Novels"
                onClick={() => setNav(false)}
                className={({ isActive }) =>
                  isActive
                    ? " text-tertiary text-[14px] md:text-[16px]"
                    : " text-primarys text-[14px] md:text-[16px]"
                }
              >
                Browse
              </NavLink>
              <NavLink
                // className="hover:text-primarys duration-300 ease-in-out"
                to="/create"
                title="Create Your Own Novel"
                onClick={() => setNav(false)}
                className={({ isActive }) =>
                  isActive
                    ? " text-tertiary text-[14px] md:text-[16px]"
                    : " text-primarys text-[14px] md:text-[16px]"
                }
              >
                Create
              </NavLink>
              <NavLink
                to="/favorites"
                title="Your Own Favorites Novels"
                onClick={() => setNav(false)}
                className={({ isActive }) =>
                  isActive
                    ? "relative text-tertiary text-[14px] md:text-[16px]"
                    : "relative text-primarys text-[14px] md:text-[16px]"
                }
              >
                Favorites
                {/* if he had any favorites then a circle will appear */}
                {localUser?.favoriteNovels?.length ? (
                  <div className="absolute opacity-100 duration-500 ease-in-out pointer-events-none top-0 right-0 -m-2">
                    <div className="relative w-2 h-2 bg-primary  flex justify-center items-center rounded-full">
                      <div className="w-4 h-4 absolute bg-primary/50 -z-10 rounded-full animate-ping"></div>
                    </div>
                  </div>
                ) : (
                  <div className="absolute opacity-0 duration-500 ease-in-out pointer-events-none top-0 right-0 -m-2">
                    <div className="relative w-2 h-2 bg-primary  flex justify-center items-center rounded-full">
                      <div className="w-4 h-4 absolute bg-primary/50 -z-10 rounded-full animate-ping"></div>
                    </div>
                  </div>
                )}
              </NavLink>
            </div>
            <div className="w-[80%] lg:hidden h-[0.5px] bg-tertiary/20"></div>
            {user ? (
              <div className="flex flex-col lg:flex-row lg:space-y-0 lg:space-x-10">
                <div className="hidden lg:flex flex-row-reverse gap-x-4 items-center">
                  {localUser?.picture ? (
                    <div>
                      <div
                        title="My Profile"
                        className="cursor-pointer flex uppercase justify-center items-center h-[50px] w-[50px] bg-secondary z-50 relative rounded-full"
                      >
                        <img
                          onClick={() => {
                            setUserPopup((prev) => !prev);
                          }}
                          className="rounded-full object-cover h-full w-full"
                          src={localUser?.picture}
                          alt={localUser?.firstName}
                          referrerPolicy="no-referrer"
                        />
                      </div>
                      {ProfilePopUp}
                    </div>
                  ) : (
                    <div>
                      <div
                        onClick={() => {
                          setUserPopup((prev) => !prev);
                        }}
                        title="My Profile"
                        className="cursor-pointer flex uppercase justify-center items-center h-[50px] w-[50px] bg-primary z-50 relative rounded-full"
                      >
                        {localUser?.firstName?.[0] || "#"}
                      </div>
                      {ProfilePopUp}
                    </div>
                  )}
                </div>

                <button
                  onClick={logOut}
                  title="Log out"
                  className="Purple-btn-effect text-[14px] md:text-[16px] full-width lg:relative  lg:left-0  font-SoraR hover:bg-primary/90 lg:w-[163px] h-[52px] bg-primary relative hover:text-primarys duration-300 ease-in-out"
                >
                  Log out
                </button>
              </div>
            ) : (
              <div className="flex flex-col lg:flex-row space-y-10 lg:space-y-0 lg:space-x-10">
                <button
                  onClick={() => {
                    setInterfaces(
                      2,
                      setTimeout(() => {
                        setPopUp(true);
                      }, 10)
                    );
                  }}
                  title="Login"
                  className="hover:text-primarys text-[14px] md:text-[16px] duration-300 ease-in-out"
                >
                  Login
                </button>
                <button
                  onClick={() => {
                    setInterfaces(
                      0,
                      setTimeout(() => {
                        setPopUp(true);
                      }, 10)
                    );
                  }}
                  title="Get Started"
                  className="Purple-btn-effect text-[14px] md:text-[16px] mx-10 full-width lg:relative lg:left-0 font-SoraR hover:bg-primary/90 lg:w-[163px] h-[52px] bg-primary relative hover:text-primarys duration-300 ease-in-out"
                >
                  Get Started
                </button>
              </div>
            )}
          </div>
        </div>

        {/* eye */}
        <div className="z-[120]">
          <div
            onClick={() => setNav(false)}
            className="triangle z-[120] relative"
          >
            <NavLink aria-label="The EyeNovel" to="/">
              <Eye />
            </NavLink>
          </div>
        </div>
        {/* eye */}
        <div className="">
          <div className="full-width z-[150] relative">
            <div className="z-[150] h-[0.5px] bg-tertiary/20"></div>
          </div>
        </div>
      </div>

      <div
        onClick={() => setPopUp(false)}
        className={
          popup
            ? "absolute z-[1000] purple-full-width  backdrop-blur-[50px] bg-secondary/20 top-0 left-0 h-full w-full opacity-100  duration-500 ease-in-out"
            : "absolute z-[1000] purple-full-width  backdrop-blur-[50px] bg-secondary/20 top-0 left-0 h-full w-full opacity-0 pointer-events-none duration-500 ease-in-out"
        }
      ></div>
      {interfaces === 0 && (
        <MainInterface
          setPopUp={setPopUp}
          popup={popup}
          setInterfaces={setInterfaces}
        />
      )}
      {interfaces === 1 && (
        <SignUp
          setPopUp={setPopUp}
          popup={popup}
          setInterfaces={setInterfaces}
        />
      )}
      {interfaces === 2 && (
        <Login
          setPopUp={setPopUp}
          popup={popup}
          setInterfaces={setInterfaces}
        />
      )}
    </div>
  );
}

export default Nav;
